module.exports = __webpack_public_path__ + "img/visual-banner.69412392.png";